import type { ConfigError } from '@/config/loadConfig';

/**
 * The single failure surface of the app.
 *
 * The text is exactly `invalid url`, lowercase, as in the legacy app — operators on site
 * recognise it and report it verbatim. The reason is shown only in dev; on a wall the
 * screen stays clean and the detail goes to the console instead.
 */
export function InvalidUrl({ reason }: { reason?: ConfigError }) {
  return (
    <div className="p-4">
      <div>invalid url</div>
      {import.meta.env.DEV && reason !== undefined && (
        <pre className="mt-4 text-xs whitespace-pre-wrap opacity-70">
          {JSON.stringify(reason, null, 2)}
        </pre>
      )}
    </div>
  );
}
